import { Module } from 'vuex';

import tool from '@/utils/tool';
import RootModuleTypes from '@/store/interface';
import MembershipFeesModuleTypes from '@/store/modules/middleGround/member/membershipFees/interface';

const membershipFeesModule: Module<MembershipFeesModuleTypes, RootModuleTypes> =
  {
    namespaced: true,
    state: {},
    mutations: {},
    actions: {
      createWxPayOrder(context, params) {
        return new Promise((resolve, reject) => {
          tool.post('/weixinApi/createWxPayOrder', params).then((data) => {
            if (data.status === 2000) {
              resolve(data);
            } else {
              reject(data);
            }
          });
        });
      },
      pageRechargeLogListBySuccess(context, searchParams) {
        return new Promise((resolve, reject) => {
          tool
            .post('/personalCenter/pageRechargeLogListBySuccess', searchParams)
            .then((data) => {
              if (data.status === 2000) {
                resolve(data);
              } else {
                reject(data);
              }
            });
        });
      },

      pageServicePackageBuyLogList(context, searchParams) {
        return new Promise((resolve, reject) => {
          tool
            .post('/personalCenter/pageServicePackageBuyLogList', searchParams)
            .then((data) => {
              if (data.status === 2000) {
                resolve(data);
              } else {
                reject(data);
              }
            });
        });
      },

      pageServicePackageAccountList(context, searchParams) {
        return new Promise((resolve, reject) => {
          tool
            .post('/personalCenter/pageServicePackageAccountList', searchParams)
            .then((data) => {
              if (data.status === 2000) {
                resolve(data);
              } else {
                reject(data);
              }
            });
        });
      },

      getCurrUseServicePackageBuyLog(context, searchParams) {
        return new Promise((resolve, reject) => {
          tool
            .post('/personalCenter/getCurrUseServicePackageBuyLog', searchParams)
            .then((data) => {
              if (data.status === 2000) {
                resolve(data);
              } else {
                reject(data);
              }
            });
        });
      },

      pageServicePackageList(context, searchParams) {
        return new Promise((resolve, reject) => {
          tool
            .post('/personalCenter/pageServicePackageList', searchParams)
            .then((data) => {
              if (data.status === 2000) {
                resolve(data);
              } else {
                reject(data);
              }
            });
        });
      },

      servicePackageBuy(context, params) {
        return new Promise((resolve, reject) => {
          tool.post('/personalCenter/servicePackageBuy', params).then((data) => {
            if (data.status === 2000) {
              resolve(data);
            } else {
              reject(data);
            }
          });
        });
      },




      
    },
  };

export default membershipFeesModule;
